import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMouseClassic2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconMouseClassic2"><Path d="M19 15C19 18.866 15.866 22 12 22C8.13401 22 5.00001 18.866 5 15V10H19V15Z" fill="currentColor"/><Path d="M11.5 9H5V4.5C5 3.11929 6.11929 2 7.5 2H11.5V9Z" fill="currentColor"/><Path d="M16.5 2C17.8807 2 19 3.11929 19 4.5V9H12.5V2H16.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMouseClassic2;
